import { createBrowserRouter } from "react-router-dom";
import { RootLayout } from "./components/layout/RootLayout.jsx";
import { VisibilityGate } from "./components/layout/VisibilityGate.jsx";
import HomePage from "./pages/HomePage.jsx";
import HomeDesignsPage from "./pages/HomeDesignsPage.jsx";
import DesignDetailPage from "./pages/DesignDetailPage.jsx";
import HouseLandPage from "./pages/house-land/HouseLandPage.jsx";
import FacadesPage from "./pages/facades/FacadesPage.jsx";
import FloorPlansPage from "./pages/floor-plans/FloorPlansPage.jsx";
import GalleryPage from "./pages/gallery/GalleryPage.jsx";
import DisplayHomesPage from "./pages/display-homes/DisplayHomesPage.jsx";
import DisplayHomeDetailPage from "./pages/display-homes/DisplayHomeDetailPage.jsx";
import ServicesListPage from "./pages/services/ServicesListPage.jsx";
import ServiceDetailPage from "./pages/services/ServiceDetailPage.jsx";
import BlogListPage from "./pages/blog/BlogListPage.jsx";
import BlogDetailPage from "./pages/blog/BlogDetailPage.jsx";
import CompanyProfilePage from "./pages/about/CompanyProfilePage.jsx";
import WhyBuildPage from "./pages/about/WhyBuildPage.jsx";
import WhereWeBuildPage from "./pages/about/WhereWeBuildPage.jsx";
import FirstHomeBuyerPage from "./pages/get-started/FirstHomeBuyerPage.jsx";
import InvestorsPage from "./pages/get-started/InvestorsPage.jsx";
import OurProcessPage from "./pages/get-started/OurProcessPage.jsx";
import ContactPage from "./pages/contact/ContactPage.jsx";
import NewBuildContactPage from "./pages/contact/NewBuildContactPage.jsx";
import PreConstructionPage from "./pages/contact/PreConstructionPage.jsx";
import MaintenancePage from "./pages/contact/MaintenancePage.jsx";
import AppointmentPage from "./pages/contact/AppointmentPage.jsx";
import PrivacyPolicyPage from "./pages/legal/PrivacyPolicyPage.jsx";
import TermsPage from "./pages/legal/TermsPage.jsx";
import DueDiligencePage from "./pages/legal/DueDiligencePage.jsx";
import NotFoundPage from "./pages/NotFoundPage.jsx";

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      { index: true, element: <HomePage /> },

      // Home Designs catalogue — flat
      { path: "home-designs", element: <HomeDesignsPage /> },
      { path: "home-designs/:designSlug", element: <DesignDetailPage /> },

      // House & Land + Facades + Display Homes — H&L and Display Homes
      // are gated on the admin Settings page-visibility flags. Hidden
      // pages redirect to /home-designs.
      {
        path: "house-land",
        element: (
          <VisibilityGate flag="houseLand">
            <HouseLandPage />
          </VisibilityGate>
        ),
      },
      { path: "facades", element: <FacadesPage /> },
      { path: "floor-plans", element: <FloorPlansPage /> },
      { path: "gallery", element: <GalleryPage /> },
      {
        path: "display-homes",
        element: (
          <VisibilityGate flag="displayHomes">
            <DisplayHomesPage />
          </VisibilityGate>
        ),
      },
      // Location-filtered gallery uses a literal /location/ segment so it
      // never collides with the :slug detail route below.
      {
        path: "display-homes/location/:locationSlug",
        element: (
          <VisibilityGate flag="displayHomes">
            <DisplayHomesPage />
          </VisibilityGate>
        ),
      },
      {
        path: "display-homes/:slug",
        element: (
          <VisibilityGate flag="displayHomes">
            <DisplayHomeDetailPage />
          </VisibilityGate>
        ),
      },

      // Services
      { path: "services", element: <ServicesListPage /> },
      { path: "services/:slug", element: <ServiceDetailPage /> },

      // Blog
      { path: "blog", element: <BlogListPage /> },
      { path: "blog/category/:slug", element: <BlogListPage /> },
      { path: "blog/:slug", element: <BlogDetailPage /> },

      // About
      { path: "about/company-profile", element: <CompanyProfilePage /> },
      { path: "about/why-build-with-us", element: <WhyBuildPage /> },
      { path: "about/where-we-build", element: <WhereWeBuildPage /> },

      // Get started
      { path: "get-started/first-home-buyer", element: <FirstHomeBuyerPage /> },
      { path: "get-started/investors", element: <InvestorsPage /> },
      { path: "get-started/our-process", element: <OurProcessPage /> },

      // Contact
      { path: "contact-us", element: <ContactPage /> },
      { path: "contact-us/new-build", element: <NewBuildContactPage /> },
      { path: "contact-us/preconstruction", element: <PreConstructionPage /> },
      { path: "contact-us/maintenance", element: <MaintenancePage /> },
      { path: "request-an-appointment", element: <AppointmentPage /> },

      // Legal
      { path: "legal/privacy-policy", element: <PrivacyPolicyPage /> },
      { path: "legal/terms", element: <TermsPage /> },
      { path: "legal/due-diligence", element: <DueDiligencePage /> },

      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);
